import { API } from "API/API";
import { Constants } from "constants/constants";

async function submitForm(form_id, form_data) {
    const url = Constants.api_url + `wp-json/contact-form-7/v1/contact-forms/${form_id}/feedback`;
    const extra_options = {
        headers: {
        },
    }
    const result = await API.post.basic(url, form_data, extra_options);

    return result;
}

export const form = {
    submit: submitForm,
};